import React, { useEffect, useState } from 'react'
import { MAIN_URL } from '../../Constants';
import { MainTable } from '../../Components/MainTable/MainTable';
import axios from 'axios';
import { Button, Col, Form, Image, Input, InputNumber, message, Row, Tag } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

function Inventary(props) {
    let [products, setProducts] = useState([])
    useEffect(() => {
        axios.get('/variations').then(res => {
            setProducts(res.data)
        })
    }, [])

    let columns = [
        {
            key: 'img',
            title: 'Img',
            dataIndex: 'img',
            render: (text, record) => <Image alt="example" src={MAIN_URL + '/' + record.img} width={75} height={75} style={{ objectFit: 'cover' }} />
        },
        {
            key: 'model',
            title: 'Nomi',
            dataIndex: 'model',
            render: (text, record) => <div>
                <p style={{ color: 'black' }}><b>Product:</b> {record.product_name}</p>
                <p style={{ color: 'blue' }}><b>Model:</b> {record.models.map(m=><Tag color='blue' key={m.id}>{m.nameuz}</Tag>)}</p>
                <p style={{ color: 'green' }}><b>Brand:</b> {record.brands.map(b=><Tag color='green' key={b.id}>{b.nameuz}</Tag>)}</p>
                <p style={{ color: 'red' }}><b>Narxi:</b> {record.price_uzs} so'm</p>
            </div>
        },
        {
            key: 'sku',
            title: 'Info',
            dataIndex: 'sku',
            render: (text, record) => <div>
                <p style={{ color: 'indigo' }}><b>Kodi:</b> {record.sku}</p>
                <p style={{ color: 'brown' }}><b>Rang:</b> {record.color}</p>
                <p style={{ color: 'goldenrod' }}><b>Davlat:</b> {record.country}</p>
                <p style={{ color: 'black' }}><b>Ishlab chiqaruvchi:</b> {record.manufacturer}</p>
            </div>
        },
        {
            key: 'count',
            title: 'Soni',
            dataIndex: 'count',
            render: (text, record) => <Form layout='vertical' onFinish={(v) => {
                axios.put('/variationscount/' + record.id, v).then(res => {
                    message.success("Muvaffaqiyatli o'zgartirdingiz!")
                })
            }}>
                <Row>
                    <Col span={20}>
                        <Form.Item name='count' label='Soni' rules={[{ required: true }]}>
                            <InputNumber defaultValue={record.count} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item label=' '>
                            <Button type='primary' htmlType='submit' icon={<SaveOutlined />} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        }
    ]

    return (
        <div>
            <div style={{ marginBottom: '10px' }}>
                <Input placeholder="Sku bo'yicha qidirish" />
            </div>
            <MainTable
                pageTitle="Inventarizatsiya"
                pcolumns={columns}
                pdata={products}
                defkey={'id'}
            />
        </div>
    );
}

export default Inventary;